import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import CheckboxButton from '../../ui/CheckboxButton';

import TaraText from './TaraText';

export const personaOptions = [
  {
    label: 'Attending with family',
    value: 'family',
  },
  {
    label: 'I\'m a fan of the team',
    value: 'diehard_fan',
  },
  {
    label: 'Going with friends',
    value: 'friends',
  },
  {
    label: 'It\'s a company/client event',
    value: 'clients',
  },
  {
    label: 'Just browsing',
    value: 'browsing',
  },
];

const Col = glamorous.div({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  transition: 'height 300ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  animationDelay: '1600ms',
});

const styleFlex = {
  display: 'flex',
  flexDirection: 'column',
};

const styleSpaced = {
  marginBottom: 16,
};

const styleDoubleSpaced = {
  marginBottom: 32,
};

const noop = () => {};

class TaraQuestionPersona extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: noop,
  };

  createHandleClick = (value) => (e) => {
    this.props.onClick(value);
  };

  render() {
    const { persona, isAnimated } = this.props;

    return (
      <div style={persona ? { ...styleFlex, ...styleDoubleSpaced } : { ...styleFlex, ...styleSpaced }}>
        <TaraText
          isQuestion
          isAnimated={isAnimated}
        >
          First, can you tell me a <strong>bit more</strong> about your purchase?
        </TaraText>

        <Col style={{ height: persona ? 48 : 304 }} className={isAnimated ? 'animated fadeIn' : undefined}>
          {personaOptions.map((option, index) => (persona && persona !== option.value) ? null : (
            <CheckboxButton
              key={option.label}
              color={option.value === persona ? 'primary' : undefined}
              label={option.label}
              onClick={this.createHandleClick(option.value)}
              isChecked={persona === option.value}
              style={(!persona && index !== personaOptions.length - 1) && styleSpaced}
            />
          ))}
        </Col>
      </div>
    );
  }
}

export default TaraQuestionPersona;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraQuestionPersona.js